import { useMemo } from 'react';
import { Column } from 'react-table';

import { Table } from '@savgroup-front-common/core';

import type { CommandeRow } from '../../types/commande.types';
import { formatDossierDate } from '../../utils/dossierFormat';
import { $DossierTableScrollArea } from '../../pages/DossierPage.styles';

export interface CommandeTableViewProps {
  commandes: CommandeRow[];
  dataTestId?: string;
}

const CENTERED_CELL_PROPS = {
  style: { verticalAlign: 'middle' as const },
};

const CommandeTableView = ({
  commandes,
  dataTestId = 'commandes-table',
}: CommandeTableViewProps) => {
  const columns = useMemo<Column<CommandeRow>[]>(
    () => [
      {
        Header: 'N° commande',
        accessor: 'numeroCommande',
        getProps: () => CENTERED_CELL_PROPS,
      },
      {
        Header: "Date d'achat",
        accessor: 'dateAchat',
        Cell: ({ value }: { value: string }) => formatDossierDate(value),
        getProps: () => CENTERED_CELL_PROPS,
      },
      {
        Header: 'Nombre de produits',
        accessor: 'nombreProduits',
        getProps: () => CENTERED_CELL_PROPS,
      },
      {
        Header: 'Client',
        id: 'client',
        accessor: (row: CommandeRow) => `${row.clientPrenom} ${row.clientNom}`.trim(),
        getProps: () => CENTERED_CELL_PROPS,
      },
    ],
    [],
  );

  return (
    <$DossierTableScrollArea>
      <Table<CommandeRow> columns={columns} data={commandes} dataTestId={dataTestId} />
    </$DossierTableScrollArea>
  );
};

export default CommandeTableView;
